import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import 'rxjs/add/operator/catch';
import {BlogService} from "../../../api/blog/blog.service";
import {BlogcategoryService} from "../../../api/blogcategory/blogcategory.service";

declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'application-page',
    templateUrl: './blog.html'
})

export class Blog implements OnInit {
    blog = [];
    i: number;
    id: string;
    TableData = [];
    title: string;
    desc: string;
    role: string;
    subtitle: string;
    description: string;
    isactive: boolean;
    blogimage: string;
    image_file: File;
    selectedType = 1;
    thisUserId: string;
    image_url: string;
    public showinputblog: boolean = false;
    public showoriginalblog: boolean = true;
    tag: string;
    html: string;
    keywords = [];
    blogcategory = [];
    suggesttag = [];
    selectedtag = [];

    constructor(private blogService: BlogService, private blogcategoryService: BlogcategoryService,
                private router: Router) {
    }

    ngOnInit() {
     
        $(function () {
            $('.summernote').summernote({
                height: 350
            });
        });
        $(function () {
            $('.summernote2').summernote({
                height: 350
            });
        });
        $(function () {
            $('.select2').select2();
            $('.select2-tags').select2({
                tags: true,
                tokenSeparators: [',', ' ']
            });
            $('.selectpicker').selectpicker();
        });
        $(function () {
            var drEvent = $('.dropify').dropify();
            drEvent.on('dropify.afterClear', function (event, element) {
            });
        });
        this.image_url = "http://localhost:5500/uploads/blog_image/";
        this.thisUserId = localStorage.getItem('id');
        this.role = localStorage.getItem('role');
        if (localStorage.getItem('token')) {
            this.blogService.allBlog(this.thisUserId)
                .then(data => {
                    this.blog = data.data;
                    this.suggesttag = data.tags;
                   
                });
            this.blogcategoryService.allBlogcategory()
                .then(data => {
                    this.blogcategory = data;
                });
        } else {
            this.router.navigate(['/']);
        }
    }

    /*trustAsHtml(string) {
     return $sce.trustAsHtml(string);
     };*/
    removeblogimages() {
        this.showinputblog = true;
        this.showoriginalblog = false;
        this.blogimage = null;
        $(function () {
            var drEvent = $('.dropify').dropify();
            drEvent.on('dropify.afterClear', function (event, element) {
            });
        });
    }

    onChange(value) {
        this.selectedType = value;
    }

    detectFilesblogimage(event) {
        this.image_file = <File>event.target.files[0];
    }

    cancelAction() {
        this.id = "";
        this.title = "";
        this.desc = "";
        this.selectedtag = [];
        this.selectedType = 1;
        $('div.note-editable').html("")
    }

    submitBlog() {
        var descriptionhtml = $('div.note-editable').html();
        var column1RelArray = [];
        $('.select2-selection__rendered li').each(function () {
            column1RelArray.push($(this).attr('title'));
        });
        column1RelArray = column1RelArray.filter(function (element) {
            return element !== undefined;
        });
        if (this.title == undefined || this.title == undefined) {
            $.notify({
                message: "Please Enter Title"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        else if (column1RelArray == [] || column1RelArray == null) {
            $.notify({
                message: "Please Enter Atleast One Tag"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        else {
            if (this.image_file != undefined) {
                var is_formdata = true
            } else {
                var is_formdata = false
            }
            var JsonObject = {
                title: this.title,
                desc: descriptionhtml,
                blogcategory: this.selectedType,
                tag: column1RelArray.toString(),
                createdById: this.thisUserId
            };
            this.blogService.iBlog(JsonObject, this.image_file, is_formdata).then(data => {
                if (data.status) {
                    this.blogService.allBlog(this.thisUserId)
                        .then(data => {
                            this.blog = data.data;
                            this.suggesttag = data.tags;
                        });
                    this.cancelAction();
                    $(function () {
                        $('#addBlog').modal('toggle');
                    });
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
        }
    }

    showBlog(blog, i) {
        this.i = i;
        this.id = blog.id;
        this.title = blog.title;
        this.desc = blog.desc;
        this.blogimage = blog.blogimage;
        this.selectedType = blog.blogcategory;
        if (this.desc != null) {
            $('div.note-editable').append(this.desc);
        }
        if (this.blogimage == null) {
            this.showinputblog = true;
            this.showoriginalblog = false;
        } else {
            this.showinputblog = false;
            this.showoriginalblog = true;
        }

        var str = blog.tag;
        var arr = str.split(",");
        var tagarr = [];
        for (var j = 0; j < this.suggesttag.length; j++) {
            tagarr[j] = this.suggesttag[j].id;
        }
        var tagarray = tagarr.map(String);
        const intersection = arr.filter(element => tagarray.includes(element));
        var inttagarray = intersection.map(Number);
        var selectedtag = [];
        for (var k = 0; k < this.suggesttag.length; k++) {
            for (var z = 0; z < this.suggesttag.length; z++) {
                if (inttagarray[k] == this.suggesttag[z].id) {
                    selectedtag[k] = this.suggesttag[z].name;
                }
            }
        }

        this.selectedtag = selectedtag;
    }

    gettingsequence() {
        var TableData = new Array();
        $('#row-table tr').each(function (row, tr) {
            TableData[row] = {
                "id": $(tr).find('td:eq(0)').text(),
                "index": row - 1
            }
        });
        TableData.shift();
        this.TableData = TableData;
        var tbdata = {
            tabledata: this.TableData
        };
        this.blogService.uHiringindex(tbdata).then(data => {
            if (data.status) {
                this.blogService.allBlog(this.thisUserId)
                    .then(data => {
                        this.blog = data.data;
                        this.suggesttag = data.tags;
                    });
                // this.cancelAction();
            } else {
                // this.cancelAction();
            }
        });
    }

    deleteconfirmation(id, i) {
        //alert(JSON.stringify(keydata))
        this.i = i;
        this.id = id;
    }

    updateBlog() {
        var descriptionhtml = $('.summernote2').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').html();
        var column1RelArray = [];
        $('.select2-selection__rendered li').each(function () {
            column1RelArray.push($(this).attr('title'));
        });
        column1RelArray = column1RelArray.filter(function (element) {
            return element !== undefined;
        });
        if (this.title == undefined || this.title == undefined) {
            $.notify({
                message: "Please Enter Title"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        else if (column1RelArray == [] || column1RelArray == null) {
            $.notify({
                message: "Please Enter Atleast One Tag"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        else {
            if (this.image_file != undefined) {
                var is_formdata = true
            } else {
                var is_formdata = false
            }
            var JsonObject = {
                title: this.title,
                desc: descriptionhtml,
                blogcategory: this.selectedType,
                tag: column1RelArray.toString(),
                createdById: this.thisUserId
            };
            this.blogService.uBlog(this.id, JsonObject, this.image_file, is_formdata).then(data => {
                if (data.status) {
                    this.blogService.allBlog(this.thisUserId)
                        .then(data => {
                            this.blog = data.data;
                            this.suggesttag = data.tags;
                        });
                    this.cancelAction();
                    $(function () {
                        $('#updateBlog').modal('toggle');
                    });
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
        }
    }

    deleteHiring() {
        this.blogService.dHiring(this.id).then(data => {
            if (data.status) {
                this.blogService.allBlog(this.thisUserId)
                    .then(data => {
                        this.blog = data.data;
                        this.suggesttag = data.tags;
                    });
            } else {
                this.cancelAction();
            }
        });
    }
}





// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/blog/blog.page.ts